import { render, staticRenderFns } from "./UserPartners.vue?vue&type=template&id=a8f72162&scoped=true&"
import script from "./UserPartners.vue?vue&type=script&lang=js&"
export * from "./UserPartners.vue?vue&type=script&lang=js&"
import style0 from "./UserPartners.vue?vue&type=style&index=0&id=a8f72162&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f72162",
  null
  
)

export default component.exports